import { combineReducers } from 'redux';
import moment from 'moment';

import {
    ACCESS_PAGE_INFO_RETRIEVED,
    ACCESS_PAGE_INFO_LOADING,
    DEBTOR_AUTHENTICATED,
    DEAL_CREATED,
    DEAL_CREATE_LOADING,
    SETTED_DEBTOR_PARAMS,
    SETTED_DEAL,
    SETTED_OFFER_BAR,
    LOADED_DEAL_INSTALLMENTS_INFORMATION,
    SETTED_SELECTED_INSTALLMENTS,
    SETTED_SELECTED_DEBT,
    SIMULATED_DEBT,
    DEBT_SIMULATION_DATE_CHANGED,
    DEBT_INSTALLMENTS_SELECTED_CHANGED,
    PAYMENT_TYPE_CHANGED,
} from 'modules/debtor-area/actions/debtor-area.action';



export const debtorParams = (state = null, action) => {
    switch (action.type) {
        case SETTED_DEBTOR_PARAMS:
            return action.payload;
        default:
            return state;
    }
};

export const loadingAccessPageInfo = (state = false, action) => {
    switch (action.type) {
        case ACCESS_PAGE_INFO_LOADING:
            return action.payload;
        default:
            return state;
    }
};

export const accessPageInfo = (state = null, action) => {
    switch (action.type) {
        case ACCESS_PAGE_INFO_RETRIEVED:
            return action.payload;
        default:
            return state;
    }
};

export const debtor = (state = null, action) => {
    switch (action.type) {
        case DEBTOR_AUTHENTICATED:
            return action.payload;
        default:
            return state;
    }
};

export const selectedDebt = (state = null, action) => {
    
    switch (action.type) {
        case DEBTOR_AUTHENTICATED:
            return (action.payload && action.payload.debts.length >= 1)
                ? action.payload.debts[0]
                : state;
        case SETTED_SELECTED_DEBT:
            return action.payload;
        default:
            return state;
    }
};

export const selectedInstallments = (state = [], action) => {
    switch (action.type) {
        case SETTED_SELECTED_INSTALLMENTS:
            return action.payload;
        default:
            return state;
    }
};

export const simulatedDebt = (state = null, action) => {
    switch (action.type) {
        case SIMULATED_DEBT:
            return action.payload;
        default:
            return state;
    }
};

export const debtSimulationDate = (state = moment(), action) => {
    switch (action.type) {
        case DEBT_SIMULATION_DATE_CHANGED:
            return action.payload;
        default: 
            return state;
    }
}

export const dealCreateLoading = (state = false, action) => {
    switch (action.type) {
        case DEAL_CREATE_LOADING:
            return action.payload;
        default:
            return state;
    }
};

export const offer = (state = null, action) => {
    switch (action.type) {
        case DEAL_CREATED:
            return action.payload;
        case SETTED_DEAL:
            return action.payload;
        default:
            return state;
    }
};

export const offerBar = (state = null, action) => {
    switch (action.type) {
        case SETTED_OFFER_BAR:
            return action.payload;
        default:
            return state;
    }
};

export const installmentOfferRule = (state = null, action) => {
    switch (action.type) {
        case LOADED_DEAL_INSTALLMENTS_INFORMATION:
            return action.payload;
        default:
            return state;
    }
};

export const debtInstallmentsSelected = (state = [], action) => {
    switch (action.type) {
        case DEBT_INSTALLMENTS_SELECTED_CHANGED:
            return action.payload;
        default:
            return state;
    }
};

export const selectedPaymentType = (state = null, action) => {
    switch (action.type) {
        case PAYMENT_TYPE_CHANGED:
            return action.payload;
        default:
            return state;
    }
};

export default combineReducers({
    debtorParams,
    accessPageInfo,
    debtor,
    selectedDebt,
    loadingAccessPageInfo,
    offer,
    dealCreateLoading,
    offerBar,
    installmentOfferRule,
    selectedInstallments,
    simulatedDebt,
    debtSimulationDate,
    debtInstallmentsSelected,
    selectedPaymentType,
});
